export const all_routes = {
 
  home: "/",
  signup: "/register",
  login: "/login",
  forgotpassword: "/authentication/forgot-password",
  resetpassword: "/authentication/reset-password",
  about: "/about",
  listinggrid: "/package",
  listinglist: "/package/listing-list",
  listingdetails: "/package",
  legacyListingdetails: "/package/details",
  pricing: "/pages/pricing",
  faq: "/faq",
  gallery: "/pages/gallery",
  bloglist: "/blog",
  bloggrid: "/blog",
  blogdetails: "/blog",
  bookingcheckout: "/pages/booking-payment",
  booking: "/pages/booking",
  invoice: "/pages/invoice-details",
  ourteam: "/pages/our-team",
  testimonial: "/pages/testimonial",
  termsconditions: "/pages/terms-condition",
  privacypolicy: "/privacy-policy",
  legacyPrivacypolicy: "/pages/privacy-policy",
  maintenance: "/pages/maintenance",
  comingsoon: "/pages/coming-soon",
  error404: "/pages/error-404",
  error500: "/pages/error-500",
  contact: "/contact",
  taxiServiceMakkah: "/taxi-service-makkah",
  taxiServiceMadinah: "/taxi-service-madinah",
  jaddahAirportTaxiService: "/jaddah-airport-taxi-service",
  hotelTransport: "/hotel-transport",
  ziyaratTaxiService: "/ziyarat-taxi-service",
  legacyZiyaratTaxiService: "/ziyarat-tax-service",
  airportTransfers: "/airport-transfers",
  dashboard:"/user/user-dashboard",
  userbookings:"/user/user-bookings",
  reviews:"/user/user-reviews",
  wishlist:"/user/user-wishlist",
  messages:"/user/user-messages",
  userDocuments:"/user/user-documents",
  userTransportDocuments:"/user/transport-documents",
  userBookingComplete:"/user/user-booking-complete",
  userBookingCancelled:"/user/user-booking-cancelled",
  userBookingInprogress:"/user/user-booking-inprogress",
  userBookings:"/user/user-bookings",

  payment:"/user/user-payment",
  settings:"/user/user-settings",
  security:"/user/user-security",
  preference:"/user/user-preferences",
  notification:"/user/user-notifications",
  userintegration:"/user/user-integration",
  integration:"/user/user-integration",
  wallet:"/user/user-wallet",
  bookingcancelled:"/user/user-booking-cancelled",
  userBookingUpcoming:"/user/user-booking-upcoming",
};
